import { Link } from 'react-router-dom';

import { BlogLayout } from './BlogLayout';
import { formatPostDate, listPosts } from './posts';

export const BlogIndexRoute = () => {
  const posts = listPosts();

  return (
    <BlogLayout>
      <section className="px-6 py-12 md:py-20">
        <div className="mx-auto max-w-3xl">
          <h1 className="font-serif text-4xl font-semibold text-text-primary md:text-5xl">
            Blog
          </h1>
          <p className="mt-4 text-lg text-text-secondary">
            Scored on plan output, the top five frontier LLMs cluster within 2.4 points. Scored
            on how well they draw context out of a user, the spread widens to 21.
          </p>

          <ul className="mt-12 space-y-8">
            {posts.length === 0 ? (
              <li className="text-text-tertiary">No posts yet.</li>
            ) : (
              posts.map(({ frontmatter }) => (
                <li
                  key={frontmatter.slug}
                  className="rounded-panel border border-border bg-surface p-6 transition hover:border-primary/40"
                >
                  <Link to={`/blog/${frontmatter.slug}`} className="block">
                    <p className="text-xs uppercase tracking-wide text-text-tertiary">
                      {formatPostDate(frontmatter.date)}
                    </p>
                    <h2 className="mt-1 font-serif text-2xl font-semibold text-text-primary">
                      {frontmatter.title}
                    </h2>
                    {frontmatter.summary ? (
                      <p className="mt-2 text-text-secondary">{frontmatter.summary}</p>
                    ) : null}
                    <p className="mt-3 text-sm font-medium text-primary">Read post →</p>
                  </Link>
                </li>
              ))
            )}
          </ul>
        </div>
      </section>
    </BlogLayout>
  );
};
